export function isOnlyQrLayout() {
    const userAgent = navigator.userAgent.toLowerCase()
    const isTouchDevice =
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        //@ts-expect-error skip
        navigator.msMaxTouchPoints > 0

    //@ts-expect-error skip
    const ua = navigator.userAgent || navigator.vendor || window.opera
    const isInstagram = ua.indexOf('Instagram') > -1

    const isTablet =
        /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
            userAgent
        )

    return (!isTouchDevice || isTablet) && !isInstagram
}
